import socket from '@/plugins/socket'
import CompetitorStatus from '@/store/model/sport/sport/CompetitorStatus'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas = datas.sort((a, b) => a.shortnameFr.localeCompare(b.shortnameFr))
      datas.forEach(item => { state.list.push(new CompetitorStatus(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportCompetitorstatus', 'Sport/CompetitorStatus/set') }
  },
  getters: {
    list: (state) => state.list,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
